import React, { Component } from 'react'
import { PolygonMap, TryMap } from '../index';
import moment from 'moment';
import truckIconUrl from '../../images/ico/deliverTruck3.svg';
import truckInactiveIconUrl from '../../images/ico/deliverTruckInactive.svg';
// const socket = new WebSocket('ws://192.168.100.7:3001');

import './ActiveRoutes.css'
class ActiveRoutes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: {},
            centerLocation: null,
            routeStatus: 'all',
            currDocs: [],
            openDocs: false,
            searchTransport: '',
        }
    }
    componentDidMount() {
        const { data } = this.props
        // socket.onmessage = function (event) {
        //     const data = event.data;

        //     try {
        //         const coords = JSON.parse(data);
        //     } catch (e) {

        //     }
        // };
        if (data.length > 0) {

            this.selectRoute(0, true)
        }
    }
    async shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.data !== this.props.data) {
            this.selectRoute(0, true)
        }
    }
    filterData = () => {
        const { routeStatus } = this.state
        const { data } = this.props
        let newData = []
        for (let index = 0; index < data.length; index++) {
            const doc = data[index];
            let deliveryDocsTotal = this.getDeliveryDocs(doc)
            let completeRoutePercent = this.getCompleteRoutePerc(deliveryDocsTotal, doc?.AssignedDocs?.length || 0)
            switch (routeStatus) {
                case 'all':
                    newData.push(doc)
                    break;
                case 'active':
                    if (completeRoutePercent < 100) {
                        newData.push(doc)
                    }
                    break;
                case 'complete':
                    if (completeRoutePercent == 100) {
                        newData.push(doc)
                    }
                    break;

                default:
                    break;
            }

        }
        this.setState({
            currDocs: newData
        })
        return newData
    }
    selectRoute = (index, forced = false) => {
        const newData = this.filterData()
        const { selected, } = this.state
        const { localizations } = this.props
        let newSelection = {}
        let newLocation = null
        if (newData[index]) {


            if (!selected || (selected.Code != newData[index].Code)) {
                newSelection = newData[index]
                newLocation = {
                    lng: Number(parseFloat(newData[index].LNG).toFixed(4)),
                    lat: Number(parseFloat(newData[index].LAT).toFixed(4)),
                }
            }
            if (forced) {
                newSelection = newData[index]
                newLocation = {
                    lng: Number(parseFloat(newData[index].LNG).toFixed(4)),
                    lat: Number(parseFloat(newData[index].LAT).toFixed(4)),
                }
            }
        }

        // if(newSelection){
        //     newLocation = localizations.find(geo=> geo.deviceId == newSelection?.DEV_ID)
        // }
        this.setState({
            selected: newSelection,
            centerLocation: newLocation
        })
    }

    getElapsedTime = (currDate) => {
        let elapsedTimeLabel = '--'
        if (currDate) {
            const date = currDate.split('.')[0];
            const format = "YYYY-MM-DD HH:mm:ss";
            const lastDate = moment.utc(date, format).local();

            if (lastDate.isValid()) {
                const nowDate = moment();
                const elapsedTime = moment.duration(nowDate.diff(lastDate));
                const hour = Math.floor(elapsedTime.asHours());
                const min = elapsedTime.minutes();

                const labelHr = hour === 1 ? 'hora' : 'horas';
                const labelMin = min === 1 ? 'minuto' : 'minutos';
                elapsedTimeLabel = hour > 0 ? `${hour} ${labelHr} y ` : ''
                elapsedTimeLabel += min > 0 ? `${min} ${labelMin}` : '';
                if (hour == 0 || min == 0) {
                    elapsedTimeLabel = elapsedTimeLabel.replace("y", " ");
                }
                if (elapsedTimeLabel == '') {
                    elapsedTimeLabel = 'Justo ahora'
                }
            }
        }
        return elapsedTimeLabel;
    }
    getDeliveryDocs = (userData) => {
        let totalDelivery = 0
        const assignedDocs = userData?.AssignedDocs?.filter(doc => doc.trackingInfo?.CurrStatus === 'D') || [];
        totalDelivery = assignedDocs?.length || 0
        return totalDelivery;
    }
    getStatusGuide = (status, doc) => {
        const currStatus = {
            typeProcess: '',
            label: 'En Preparación',
            style: 'bg-secondary text-white'

        }
        switch (status) {
            case 'P':
                currStatus.typeProcess = status
                currStatus.label = 'En Preparación'
                currStatus.style = 'bg-secondary text-white'
                break;
            case 'C':
                currStatus.typeProcess = status
                currStatus.label = 'Recibido'
                currStatus.style = 'bg-warning text-white'
                break;
            case 'T':
                currStatus.typeProcess = status
                currStatus.label = 'En Transito'
                currStatus.style = 'bg-info text-white'
                break;
            case 'D':
                currStatus.typeProcess = status
                currStatus.label = 'Entregado'
                currStatus.style = 'bg-success text-white'
                break;
            case 'N':
                currStatus.typeProcess = status
                currStatus.label = 'No Entregado'
                currStatus.style = 'bg-danger text-white'
                break;
            case 'R':
                currStatus.typeProcess = status
                currStatus.label = 'Retenido'
                currStatus.style = 'bg-danger text-white'
                break;

            default:
                break;
        }

        switch (doc.Transfered) {
            case 'Y':
                currStatus.typeProcess = 'Transfered'
                currStatus.label = 'Transferido'
                currStatus.style = 'bg-warning text-white'
                break;

            default:
                break;
        }

        switch (doc.CANCELED) {
            case 'Y':
                currStatus.typeProcess = 'Canceled'
                currStatus.label = 'Cancelado'
                currStatus.style = 'bg-danger text-white'
                break;

            default:
                break;
        }
        return currStatus
    }


    getCompleteRoutePerc = (deliveryDocs, totalDocs) => {
        let percentage = '--'
        const auxPercent = (deliveryDocs * 100) / totalDocs
        if (!isNaN(auxPercent)) {
            percentage = auxPercent
        }
        return percentage;
    }


    onChangeStatusRoute = (newValue) => {
        this.setState({ routeStatus: newValue },
            () => {
                this.selectRoute(0, true)
            });

    }
    openDocuments = (code) => {
        const { documentDriver } = this.props;

        if (code === -1) return;

        this.setState((prevState) => {
            const isSame = prevState.selected === code;

            return {
                openDocs: isSame ? !prevState.openDocs : true,
                selected: isSame && prevState.openDocs ? null : code
            };
        }, () => {
            if (this.state.openDocs && this.state.selected === code) {
                documentDriver(code);
            }
        });
    };

    reloadTransports = () => {
        const { getInitialData } = this.props;
        this.setState({ selected: null, openDocs: false, searchTransport: '' }, () => {
            getInitialData();
        });
    };


    render() {
        const { selected, centerLocation, routeStatus, currDocs } = this.state
        const { localizations, data, polygons, transports, currDocuments, deliveryPoints } = this.props

        const deliveryLocations = deliveryPoints;
        // let selectedLocalization = localizations.find(geo => geo.deviceId == selected?.DEV_ID)
        // let deliveryDocsTotal = this.getDeliveryDocs(selected)
        // let elapsedTime = this.getElapsedTime(selectedLocalization?.timestamp)
        // let elapedRouteTime = this.getElapsedTime(selected?.INITTIME)
        // let completeRoutePercent = this.getCompleteRoutePerc(deliveryDocsTotal, selected?.AssignedDocs?.length || 0)
        const filteredTransports = transports.filter(t => {
            const search = this.state.searchTransport.toLowerCase();

            return (
                t.PlacaVM?.toLowerCase().includes(search) ||
                t.TipodeUnidad?.toLowerCase().includes(search) ||
                t.NombreFigura?.toLowerCase().includes(search)
            );
        });
        return (
            <div className="h-100">
                <div className="container-fluid text-center h-100">
                    <div className="row h-100">
                        <div className="col-12 col-xl-4 activeRoute routeDiv" >
                            <div className="mb-2 px-2 d-flex align-items-center">
                                <input
                                    type="text"
                                    className="form-control form-control-sm me-2"
                                    placeholder="Buscar transporte..."
                                    value={this.state.searchTransport}
                                    onChange={(e) =>
                                        this.setState({ searchTransport: e.target.value })
                                    }
                                />

                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={this.reloadTransports}
                                    title="Recargar transportes"
                                >
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                            </div>


                            {filteredTransports.length > 0 ? filteredTransports.map((transport) => {
                                const isActive = this.state.selected === (transport?.CodigoAutotransporte ?? -1);

                                return (
                                    <div className="col-12 mb-1" key={transport.CodigoAutotransporte}>
                                        <div className="p-2 rounded border"
                                            style={{
                                                backgroundColor: transport.Status === 'Active' ? '#ffffffff' : '#cacacac7',
                                                borderColor: '#ccc',
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="d-flex justify-content-center justify-content-start col-3 mb-2">
                                                    <img
                                                        src={transport.Status === 'Active' ? truckIconUrl : truckInactiveIconUrl}
                                                        alt="Camión"
                                                        width={40}
                                                        height={40}
                                                    />
                                                </div>

                                                <div className="text-center col-6 mb-2">
                                                    <strong><p className="mb-0">{transport.PlacaVM}</p></strong>
                                                    <p className="mb-0 small">{transport.TipodeUnidad}</p>
                                                    <p className="mb-0" style={{ fontSize: '0.6rem' }}>{transport.NombreFigura}</p>
                                                </div>

                                                <div className="d-flex justify-content-center justify-content-end col-3">
                                                    <i
                                                        onClick={() => this.openDocuments(transport?.CodigoAutotransporte ?? -1)}
                                                        className={`fas ${isActive ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                                        style={{ fontSize: '18px', cursor: 'pointer' }}
                                                    ></i>
                                                </div>
                                            </div>


                                            {isActive && currDocuments && (
                                                <div className="mt-2 px-3">
                                                    {currDocuments.length > 0 ? (
                                                        <ul className="list-group">
                                                            {currDocuments.map((doc) => {
                                                                const statusGuideData = this.getStatusGuide(doc?.Status, doc);
                                                                return (

                                                                    <li className="list-group-item p-0 d-flex align-items-start mb-1" style={{ minWidth: '200px' }} key={`${doc.IdRTDOC}-${doc.DocEntry}`}>

                                                                        <div className="card flex-grow-1 p-2">

                                                                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">


                                                                                <span className={`badge ${statusGuideData.style} order-0 order-md-1 mb-2 mb-md-0`} style={{ fontSize: '0.7rem' }}>
                                                                                    {statusGuideData.label}
                                                                                </span>


                                                                                {/* <span className="badge bg-light text-dark order-1 order-md-0" style={{ fontSize: '0.7rem' }}>
                                                                                    Guía: {doc.TrackingGuide}
                                                                                </span> */}
                                                                                <span className="badge bg-light text-dark order-1 order-md-0" style={{ fontSize: '0.7rem' }}>
                                                                                    Ruta: {doc.Code}
                                                                                </span>
                                                                            </div>


                                                                            <h5 className="mt-2" style={{ fontSize: '0.9rem' }}>{doc.NumAtCard || doc.DocNum}</h5>
                                                                            <p className="mb-1" style={{ fontSize: '0.8rem' }}>{doc.CardName}</p>
                                                                            <p className="mb-1" style={{ fontSize: '0.7rem' }}>
                                                                                <i className="fas fa-map-marker-alt me-1"></i>
                                                                                {doc?.Street ?? ''}
                                                                            </p>
                                                                        </div>

                                                                    </li>

                                                                )
                                                            })}
                                                        </ul>
                                                    ) : (
                                                        <div className="text-muted">Sin documentos</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            }) : <p>Cargando...</p>}



                        </div>
                        <div className="col-12 col-xl-8 activeRoute " style={{ width: '100%', position: 'relative', zIndex: 0 }}>
                            <PolygonMap
                                polygons={polygons}
                                deliveryLocations={deliveryLocations}
                                localizations={localizations}
                                centerLocation={centerLocation}
                            />
                        </div>
                    </div>
                </div>
            </div>


            // <div className="container-fluid d-flex">
            //     {/* <Sidebar /> */}
            //     <div className="col-3 bg-light p-3">
            //         <h5>En ruta</h5>
            //         <select className="form-control"
            //             onChange={(e) => this.onChangeStatusRoute(e.target.value)}
            //             value={this.state.routeStatus}
            //         >
            //             <option value="all">Todas</option>
            //             <option value="active">Activas</option>
            //             <option value="complete">Completado</option>
            //         </select>
            //         {/* <select className="form-select w-auto"
            //             onChange={(e) => this.onChangeStatusRoute(e.target.value)}>
            //             <option value="all">Todas</option>
            //             <option value="active">Activas</option>
            //             <option value="complete">Completado</option>
            //         </select> */}
            //         <ul className="list-group">
            //             {currDocs.map((route, index) => {
            //                 return (
            //                     <li className="list-group-item"
            //                         onClick={() => this.selectRoute(index)}
            //                         style={{ cursor: 'pointer' }}
            //                     >
            //                         <div className="d-flex align-items-center p-2 rounded bg-light shadow-sm">
            //                             <div
            //                                 className="rounded-circle bg-secondary  text-white d-flex justify-content-center align-items-center"
            //                                 style={{ width: "40px", height: "40px", fontWeight: "bold" }}
            //                             >
            //                                 {route?.NombreFigura?.charAt(0) || ''}
            //                             </div>
            //                             <div className="ms-3 ml-2">
            //                                 <h6 className="mb-1 text-dark" style={{ fontSize: "1rem" }}>
            //                                     {route?.Code || ''}
            //                                 </h6>
            //                                 <div className="text-muted" style={{ fontSize: "0.9rem" }}>
            //                                     {route?.NombreFigura || ''}
            //                                 </div>
            //                                 <div className="text-secondary" style={{ fontSize: "0.8rem" }}>
            //                                     {route?.TipodeUnidad || ''}
            //                                 </div>
            //                             </div>
            //                         </div>

            //                     </li>
            //                 )
            //             })}
            //         </ul>
            //     </div>
            //     {/* {selected.Code && */}
            //     <div className="col-3  text-dark p-3">
            //         <div className="d-flex align-items-center p-2 rounded bg-light shadow-sm">
            //             <div
            //                 className="rounded-circle bg-secondary  text-white d-flex justify-content-center align-items-center"
            //                 style={{ width: "40px", height: "40px", fontWeight: "bold" }}
            //             >
            //                 {selected?.NombreFigura?.charAt(0) || ''}
            //             </div>
            //             <div className="ms-3 ml-2">
            //                 <h6 className="mb-1 text-dark" style={{ fontSize: "1rem" }}>
            //                     {selected?.Code || ''}
            //                 </h6>
            //                 <div className="text-muted" style={{ fontSize: "0.9rem" }}>
            //                     {selected?.NombreFigura || ''}
            //                 </div>
            //                 <div className="text-secondary" style={{ fontSize: "0.8rem" }}>
            //                     {selected?.TipodeUnidad || ''}
            //                 </div>
            //             </div>
            //         </div>
            //         <div className="bg-white p-3 rounded shadow-sm">
            //             <div className="d-flex justify-content-between">
            //                 <div>
            //                     <p className="mb-1 fw-bold"><i class="fa fa-check-square mr-2" aria-hidden="true"></i>{deliveryDocsTotal}/{selected?.AssignedDocs?.length ?? 0}</p>
            //                     <p className="text-muted small">Guías gestionadas</p>
            //                 </div>
            //                 <div>
            //                     <p className="mb-1 fw-bold"><i class="fa fa-map-marker mr-2" aria-hidden="true"></i>{parseFloat(selectedLocalization?.distanceKm).toFixed(2) ?? '--'} KM</p>
            //                     <p className="text-muted small">Distancia recorrida</p>
            //                 </div>
            //             </div>
            //             <div className="d-flex justify-content-between mt-2">
            //                 <div>
            //                     <p className="mb-1 fw-bold"><i class="fa fa-clock-o mr-2" aria-hidden="true"></i>{elapedRouteTime}</p>
            //                     <p className="text-muted small">Tiempo de ruta</p>
            //                 </div>
            //                 <div>
            //                     <p className="mb-1 fw-bold"><i class="fa fa-bed mr-2" aria-hidden="true"></i>{elapsedTime}</p>
            //                     <p className="text-muted small">Tiempo sin actividad</p>
            //                 </div>
            //             </div>
            //         </div>
            //         <div className="p-2">
            //             <div className="bg-secondary text-white p-2 rounded">
            //                 Rutas terminadas <strong>{parseFloat(completeRoutePercent).toFixed(2)}%</strong>
            //             </div>
            //         </div>
            //         <div className="container mt-3">
            //             {selected?.AssignedDocs?.map((stop, index) => {
            //                 const statusGuideData = this.getStatusGuide(stop?.trackingInfo?.CurrStatus);
            //                 return (<div className="d-flex">
            //                     {/* Línea y círculo */}
            //                     <div className="d-flex flex-column align-items-center me-2">
            //                         <div className="bg-secondary" style={{ width: "2.5px", height: "20%" }}></div>
            //                         <div className="rounded-circle bg-success " style={{ width: "20px", height: "20px" }}></div>
            //                         <div className="bg-secondary" style={{ width: "2.5px", height: "80%" }}></div>
            //                     </div>

            //                     {/* Tarjeta de información */}
            //                     <div className="card flex-grow-1 shadow-sm p-2">
            //                         <div className="d-flex align-items-center justify-content-between">

            //                             <span className="badge bg-light text-dark">Guia: {stop.TrackingGuide}</span>
            //                             <span className={`badge ${statusGuideData.style}`}>{statusGuideData.label}</span>
            //                         </div>
            //                         <h5 className="mt-2">{stop.NumAtCard ?? stop.DocNum}</h5>
            //                         <p className="mb-1">{stop.CardName}</p>
            //                         <p className="mb-1" style={{ fontSize: '12px' }}>
            //                             <i className="fas fa-map-marker-alt" style={{ marginRight: '4px' }}></i>
            //                             {stop?.ShipAddress?.Street ?? ''}</p>
            //                     </div>
            //                 </div>)
            //             })}
            //         </div>

            //     </div>

            //     {/* <RouteDetails /> */}

            //     <div className="col-6 bg-secondary text-white p-3" style={{ height: '60vh' }}>
            //         {/* <div className="card"> */}
            //         <PolygonMap
            //             polygons={polygons}
            //             deliveryLocations={deliveryLocations}
            //             localizations={localizations}
            //              centerLocation={centerLocation}
            //         />
            //         {/* <TryMap waypoints={localizations} compHeader={this.HeaderMapInfo()} centerLocation={centerLocation} showRoute={false} /> */}
            //         {/* </div> */}
            //     </div>

            // </div>
        )
    }

    HeaderMapInfo = () => {
        return (
            <>
                {/* Longitude: {117} | Latitude:{" "}
                {117} | Zoom:{" "}
                {117} */}
                <div className="d-flex justify-content-between align-items-center p-2 border bg-secondary text-dark">
                    <span className="font-weight-bold mr-2">11</span> <span className='mr-2'>Asignadas</span>
                    <span className="font-weight-bold mr-2">85.7%</span> <span className='mr-2'>Entregadas</span>
                    <span className="font-weight-bold mr-2">0%</span> <span className='mr-2'>Parciales</span>
                    <span className="font-weight-bold mr-2">14.3%</span><span className='mr-2'>No entregadas</span>
                </div>
            </>
        )
    }
}

export default ActiveRoutes